export const TOKEN = 'token';
export const QUERY_TOKEN = '?token=';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
